import Validator from 'validator';

export default {
  projectName: v => !Validator.isEmpty(v),
  dueDate: v => Validator.isISO8601(v),
  editType: v => !Validator.isEmpty(v),
  brief: v => !Validator.isEmpty(v),
  requestedBy: v => Validator.isEmail(v),
};
